// extracted by mini-css-extract-plugin
export var programInclude__bottomCard = "ProgramIncludes-module--programInclude__bottomCard--bBQOm";
export var programInclude__container = "ProgramIncludes-module--programInclude__container---dVXH";
export var programInclude__hdng = "ProgramIncludes-module--programInclude__hdng--Q45Lk";
export var programInclude__img = "ProgramIncludes-module--programInclude__img--KnCDP";
export var programInclude__para = "ProgramIncludes-module--programInclude__para--tzlpO";